export default __webpack_public_path__ + "static/media/line-multi.90942f11.svg";